import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { c as clsx } from "../../../../chunks/clsx-DgYk2OaC.js";
import { useRadioProvider } from "./hooks/useRadioContext.js";
import { h as helpers } from "../../../../chunks/helpers.module-CuLQagYQ.js";
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f, f as focus } from "../../../../chunks/FocusRing.module-Bq14yC3x.js";
import { $ as $884aeceb3d67f00f$export$37b65e5b5444d35c } from "../../../../chunks/utils-BCo8X9rB.js";
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from "../../../../chunks/mergeProps-CiRkc-tR.js";
import { $ as $65484d02dcb7eb3e$export$457c3d6518dd4c6f } from "../../../../chunks/filterDOMProps-EDDcM64A.js";
import { $ as $99facab73266f662$export$5add1d006293d136, a as $e93e671b31057976$export$b8473d3665f3a75a } from "../../../../chunks/useFormValidation-DQtKDLSx.js";
import { $ as $f6c31cce2adf654f$export$45712eceda6fad21, a as $f645667febf57a63$export$4c014de7c8940b4c } from "../../../../chunks/useFocusable-Br3TiRXg.js";
function $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, ref) {
  let { value, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby } = props;
  const isDisabled = props.isDisabled || state.isDisabled;
  let hasChildren = children != null;
  let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
  if (!hasChildren && !hasAriaLabel) console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let checked = state.selectedValue === value;
  let onChange = (e) => {
    e.stopPropagation();
    state.setSelectedValue(value);
  };
  let { pressProps, isPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled
  });
  let { pressProps: labelProps, isPressed: isLabelPressed } = $f6c31cce2adf654f$export$45712eceda6fad21({
    isDisabled,
    onPress() {
      var _ref_current;
      state.setSelectedValue(value);
      (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
    }
  });
  let { focusableProps } = $f645667febf57a63$export$4c014de7c8940b4c($3ef42575df84b30b$export$9d1611c77c2fe928(props, {
    onFocus: () => state.setLastFocusedValue(value)
  }), ref);
  let interactions = $3ef42575df84b30b$export$9d1611c77c2fe928(pressProps, focusableProps);
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  let tabIndex = -1;
  if (state.selectedValue != null) {
    if (state.selectedValue === value) tabIndex = 0;
  } else if (state.lastFocusedValue === value || state.lastFocusedValue == null) tabIndex = 0;
  if (isDisabled) tabIndex = void 0;
  let { name, descriptionId, errorMessageId, validationBehavior } = $884aeceb3d67f00f$export$37b65e5b5444d35c.get(state);
  $99facab73266f662$export$5add1d006293d136(ref, state.selectedValue, state.setSelectedValue);
  $e93e671b31057976$export$b8473d3665f3a75a({
    validationBehavior
  }, state, ref);
  return {
    labelProps: $3ef42575df84b30b$export$9d1611c77c2fe928(labelProps, {
      onClick: (e) => e.preventDefault()
    }),
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, {
      ...interactions,
      type: "radio",
      name,
      tabIndex,
      disabled: isDisabled,
      required: state.isRequired && validationBehavior === "native",
      checked,
      value,
      onChange,
      "aria-describedby": [
        props["aria-describedby"],
        state.isInvalid ? errorMessageId : null,
        descriptionId
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled,
    isSelected: checked,
    isPressed: isPressed || isLabelPressed
  };
}
const Radio = forwardRef(
  ({ selectedClassName, pressedClassName, focusedClassName, className, ...props }, ref) => {
    const radioGroupProps = useRadioProvider();
    const { state } = radioGroupProps;
    const inputRef = useRef(null);
    const { inputProps, isSelected, isPressed, labelProps } = $0d5c49892c1215da$export$37b0961d2f4751e2(props, state, inputRef);
    const { focusProps, isFocusVisible } = $f7dceffc5ad7768b$export$4e328f61c538687f();
    return /* @__PURE__ */ jsxs(
      "label",
      {
        className: clsx(className, {
          [selectedClassName || ""]: isSelected,
          [pressedClassName || ""]: isPressed,
          [focusedClassName || ""]: isFocusVisible,
          [focus.focusRing]: isFocusVisible
        }),
        ...labelProps,
        id: props.id,
        children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              ...$3ef42575df84b30b$export$9d1611c77c2fe928(inputProps, focusProps),
              ref: ref || inputRef,
              className: helpers.srOnly
            }
          ),
          props.children
        ]
      }
    );
  }
);
export {
  Radio
};
